//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { RequestError } from '@utils/sessionFetch';

/**
 * Checks for an instance of a `RequestError` (the form of error outputted by gateway request failures)
 * or a message field on a given error and returns the appropriate message string.
 *
 * @param e Suspected `RequestError`. These are automatically typed as `unknown` in catch statements
 * as of Typescript 4.4.
 */
export const getRequestErrorMessage = (e: unknown) => {
  // The given error was properly constructed as a RequestError
  if (e instanceof RequestError) {
    return e.message;
    // The given error has a message field but is not a RequestError
  } else if ((e as Error).message) {
    return (e as Error).message;
  } else {
    return undefined;
  }
};
